export default __webpack_public_path__ + "static/media/Patrec2.abb52385.png";